<template>
    <div class="chat-app">
        <conversation
            v-if="windowWidth > 1200 || conversationOpen"
            :contact="selectedContact"
            :messages="messages"
            @new="saveNewMessage"
            @back="back"
        />
        <contacts-list v-if="windowWidth > 1200 || !conversationOpen" :contacts="contacts" @selected="startConversationWith" />
    </div>
</template>

<script>
import AxiosController from '@/controllers/AxiosController'
import Conversation from '@/components/Conversation'
import ContactsList from '@/components/ContactsList'
import echo from '@/utils/echo.js'
import { isMobile } from 'mobile-device-detect'

export default {
    name: 'chat',
    components: { Conversation, ContactsList },
    props: ['user'],
    data() {
        return {
            selectedContact: null,
            messages: [],
            contacts: [],
            conversationOpen: !!this.$route.query.id,
            isMobile
        }
    },
    mounted() {
        if (!this.user.id) {
            return
        }
        this.initChat()
    },
    methods: {
        initChat() {
            this.conversationOpen = !!this.$route.query.id
            echo.private(`messages.${this.user.id}`).listen('NewMessage', e => {
                this.handleIncoming(e.message)
            })
            AxiosController.get('/get-contacts').then(res => {
                this.contacts = res.data
                if (this.$route.query.id) {
                    const contactId = this.$route.query.id
                    let selectedContact = this.contacts.find(user => user.id == contactId)
                    if (selectedContact) {
                        this.startConversationWith(selectedContact)
                    } else {
                        AxiosController.get('/users/' + contactId).then(res => {
                            selectedContact = res.data.user
                            this.contacts = [...this.contacts, selectedContact]
                            this.startConversationWith(selectedContact)
                        })
                    }
                }
            })
        },
        startConversationWith(contact) {
            this.updateUnreadCount(contact, true)
            this.messages = []
            AxiosController.get(`/conversation/${contact.id}`).then(res => {
                this.messages = res.data.reverse()
                this.selectedContact = contact
            })
        },
        saveNewMessage(message) {
            const tempContacts = [...this.contacts]
            tempContacts.find(c => c.id == message.to).lastMessageId = message.id
            tempContacts.find(c => c.id == message.to).lastMessageTitle = message.title
            this.contacts = tempContacts
            this.messages = [...this.messages, message]
        },
        handleIncoming(message) {
            if (this.selectedContact && message.from == this.selectedContact.id) {
                const tempContacts = [...this.contacts]
                tempContacts.find(c => c.id == message.from).lastMessageId = message.id
                tempContacts.find(c => c.id == message.from).lastMessageTitle = message.title
                this.contacts = tempContacts
                this.messages = [...this.messages, message]
                return
            }
            this.updateUnreadCount(message.from_contact, false)
        },
        updateUnreadCount(contact, reset) {
            this.contacts = this.contacts.map(singleContact => {
                if (singleContact.id !== contact.id) {
                    return singleContact
                }
                if (reset) singleContact.unread = 0
                else singleContact.unread += 1
                return singleContact
            })
        },
        back() {
            this.$router.push('/messages')
        }
    },
    watch: {
        $route(to, from) {
            this.initChat()
        }
    }
}
</script>

<style lang="scss" scoped>
.chat-app {
    display: flex;
    height: 100%;
}

@media (min-width: 1200px) {
    .chat-app {
        max-height: 1000px;
    }
}
</style>
